import React from "react";

import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const TermsAndConditions = ({
  agreed,
  openDialog,
  handleCheckboxChange,
  handleOpenDialog,
  handleCloseDialog,
}) => {
  return (
    <>
      <Box sx={{ mb: 1.5 }}>
        <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={agreed}
                onChange={handleCheckboxChange}
                name="agreeToTerms"
                color="primary"
              />
            }
            label="I have read and agree to the"
          />
          <Button
            onClick={handleOpenDialog}
            variant="text"
            size="small"
            sx={{ ml: -1, textTransform: "none" }}
          >
            Terms and Conditions
          </Button>
          <Typography variant="body1">.</Typography>
        </Box>

        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          aria-labelledby="terms-dialog-title"
          aria-describedby="terms-dialog-description"
          PaperProps={{
            sx: {
              width: { xs: "90%", md: "75%", lg: "50%" },
              maxWidth: "none", // Override default maxWidth to allow custom width
            },
          }}
        >
          {/* <DialogTitle id="terms-dialog-title">
            Terms and Conditions
          </DialogTitle> */}

          <DialogTitle id="terms-dialog-title" sx={{ m: 0, p: 2 }}>
            {" "}
            {/* Add padding and margin for better spacing */}
            Terms and Conditions
            {handleCloseDialog ? (
              <IconButton
                aria-label="close"
                onClick={handleCloseDialog}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </DialogTitle>

          <DialogContent dividers>
            <Typography
              sx={{ fontSize: "1.1rem" }}
              id="terms-dialog-description"
              paragraph
            >
              By registering and accessing this application, you agree to the
              following terms and conditions:
            </Typography>

            <Typography
              sx={{ fontSize: "1.1rem", fontWeight: 600 }}
              component="div"
            >
              • User Registration
              {/* Precise hanging indent for sub-points: pl indents the wrapped text, textIndent pulls the 'o' back */}
              <Typography
                component="div"
                sx={{
                  pl: "3em",
                  textIndent: "-1em",
                  fontSize: "1rem",
                  mb: 0.5,
                }}
              >
                o Registration requires a valid email address and phone number.
              </Typography>
              <Typography
                component="div"
                sx={{
                  pl: "3em",
                  textIndent: "-1em",
                  fontSize: "1rem",
                  mb: 0.5,
                }}
              >
                o The information provided during registration must be accurate
                and up to date.
              </Typography>
              <Typography
                component="div"
                sx={{
                  pl: "3em",
                  textIndent: "-1em",
                  fontSize: "1rem",
                  mb: 0.5,
                }}
              >
                o We reserve the right to verify the information provided and
                deny access if found invalid or incomplete.
              </Typography>
            </Typography>

            <Typography
              sx={{ fontSize: "1.1rem", fontWeight: 600 }}
              component="div"
            >
              • Purpose of Access
              <Typography
                component="div"
                sx={{
                  pl: "3em",
                  textIndent: "-1em",
                  fontSize: "1rem",
                  mb: 0.5,
                }}
              >
                o This account is provided solely for demonstration and
                evaluation purposes.
              </Typography>
              <Typography
                component="div"
                sx={{
                  pl: "3em",
                  textIndent: "-1em",
                  fontSize: "1rem",
                  mb: 0.5,
                }}
              >
                o Users are strictly prohibited from using the application for
                any commercial, financial, or production activities.
              </Typography>
              <Typography
                component="div"
                sx={{
                  pl: "3em",
                  textIndent: "-1em",
                  fontSize: "1rem",
                  mb: 0.5,
                }}
              >
                o The demo access is temporary and provided at the discretion of
                the client or the application administrators.
              </Typography>
            </Typography>

            <Typography
              sx={{ fontSize: "1.1rem", fontWeight: 600 }}
              component="div"
            >
              • Access Control
              <Typography
                component="div"
                sx={{
                  pl: "3em",
                  textIndent: "-1em",
                  fontSize: "1rem",
                  mb: 0.5,
                }}
              >
                o We reserve the right to revoke, suspend, or terminate user
                access at any time without prior notice, especially if misuse or
                policy violation is detected.
              </Typography>
              <Typography
                component="div"
                sx={{
                  pl: "3em",
                  textIndent: "-1em",
                  fontSize: "1rem",
                  mb: 0.5,
                }}
              >
                o Access may also be withdrawn upon completion of the demo or at
                the client’s request.
              </Typography>
            </Typography>

            <Typography
              sx={{ fontSize: "1.1rem", fontWeight: 600 }}
              component="div"
            >
              • Data Collection and Use
              <Typography
                component="div"
                sx={{
                  pl: "3em",
                  textIndent: "-1em",
                  fontSize: "1rem",
                  mb: 0.5,
                }}
              >
                o We collect user details (email, phone number, and basic usage
                data) solely for authentication, communication, and system
                improvement.
              </Typography>
              <Typography
                component="div"
                sx={{
                  pl: "3em",
                  textIndent: "-1em",
                  fontSize: "1rem",
                  mb: 0.5,
                }}
              >
                o By registering, you consent to the collection and limited use
                of this information for the stated purposes.
              </Typography>
            </Typography>

            <Typography
              sx={{ fontSize: "1.1rem", fontWeight: 600 }}
              component="div"
            >
              • Data Security and Disclaimer
              <Typography
                component="div"
                sx={{
                  pl: "3em",
                  textIndent: "-1em",
                  fontSize: "1rem",
                  mb: 0.5,
                }}
              >
                o We implement industry-standard security measures to protect
                user information from unauthorized access, misuse, or
                disclosure.
              </Typography>
              <Typography
                component="div"
                sx={{
                  pl: "3em",
                  textIndent: "-1em",
                  fontSize: "1rem",
                  mb: 0.5,
                }}
              >
                o However, no system is entirely secure, and we do not accept
                liability for any data breaches, loss, or unauthorized access
                arising from external attacks or unforeseen circumstances.
              </Typography>
              <Typography
                component="div"
                sx={{
                  pl: "3em",
                  textIndent: "-1em",
                  fontSize: "1rem",
                  mb: 0.5,
                }}
              >
                o Users are advised not to share login credentials or personal
                access details with others.
              </Typography>
            </Typography>

            <Typography
              sx={{ fontSize: "1.1rem", fontWeight: 600 }}
              component="div"
            >
              • Intellectual Property
              <Typography
                component="div"
                sx={{
                  pl: "3em",
                  textIndent: "-1em",
                  fontSize: "1rem",
                  mb: 0.5,
                }}
              >
                o All content, design, and functionalities within the
                application remain the sole property of the application owner or
                its licensors.
              </Typography>
              <Typography
                component="div"
                sx={{
                  pl: "3em",
                  textIndent: "-1em",
                  fontSize: "1rem",
                  mb: 0.5,
                }}
              >
                o Users are not permitted to copy, modify, or distribute any
                part of the application without prior written consent.
              </Typography>
            </Typography>

            <Typography
              sx={{ fontSize: "1.1rem", fontWeight: 600 }}
              component="div"
            >
              • User Conduct
              <Typography
                component="div"
                sx={{
                  pl: "3em",
                  textIndent: "-1em",
                  fontSize: "1rem",
                  mb: 0.5,
                }}
              >
                o Users must not attempt to reverse engineer, decompile, or
                disrupt the normal functioning of the application.
              </Typography>
              <Typography
                component="div"
                sx={{
                  pl: "3em",
                  textIndent: "-1em",
                  fontSize: "1rem",
                  mb: 0.5,
                }}
              >
                o Any unauthorized attempt to exploit system vulnerabilities or
                gain access to restricted areas will result in immediate
                termination of access and may lead to legal action.
              </Typography>
            </Typography>

            <Typography
              sx={{ fontSize: "1.1rem", fontWeight: 600 }}
              component="div"
            >
              • Limitation of Liability
              <Typography
                component="div"
                sx={{
                  pl: "3em",
                  textIndent: "-1em",
                  fontSize: "1rem",
                  mb: 0.5,
                }}
              >
                o The application is provided “as is” without any warranty or
                guarantee.
              </Typography>
              <Typography
                component="div"
                sx={{
                  pl: "3em",
                  textIndent: "-1em",
                  fontSize: "1rem",
                  mb: 0.5,
                }}
              >
                o We are not responsible for any direct or indirect losses
                resulting from the use or inability to use the application.
              </Typography>
            </Typography>

            <Typography
              sx={{ fontSize: "1.1rem", fontWeight: 600 }}
              component="div"
            >
              • Changes to Terms
              <Typography
                component="div"
                sx={{
                  pl: "3em",
                  textIndent: "-1em",
                  fontSize: "1rem",
                  mb: 0.5,
                }}
              >
                o These Terms and Conditions may be updated or modified at any
                time.
              </Typography>
              <Typography
                component="div"
                sx={{
                  pl: "3em",
                  textIndent: "-1em",
                  fontSize: "1rem",
                  mb: 0.5,
                }}
              >
                o Continued use of the application after changes indicates your
                acceptance of the revised terms.
              </Typography>
            </Typography>

            <Typography
              sx={{ fontSize: "1.1rem", fontWeight: 600 }}
              component="div"
            >
              • Governing Law
              <Typography
                component="div"
                sx={{
                  pl: "3em",
                  textIndent: "-1em",
                  fontSize: "1rem",
                  mb: 0.5,
                }}
              >
                o These terms shall be governed and construed in accordance with
                the laws of the jurisdiction where the application provider
                operates.
              </Typography>
            </Typography>
          </DialogContent>
          {/* <DialogActions>
            <Button onClick={handleCloseDialog} color="primary">
              Close
            </Button>
          </DialogActions> */}
        </Dialog>
      </Box>
    </>
  );
};

export default TermsAndConditions;
